import * as Html from "../util/Html.ts";
import * as amplify from "../util/amplify.ts";
import * as FwDatas from "../FwDatas.ts";
import ApiServer from "../ApiServer.ts";
import TPL from "../mealplanner/recipePreview.mustache";

var theNode: HTMLElement | null = null;

Html.registerDom({
  mppreviewclose(){
    if(theNode) {
      theNode.classList.remove('open');
    }
  },

})

function show(id){
  let item = FwDatas.get(id);
  if(item instanceof ApiServer.types.DishBean){
    item = FwDatas.get(item.recipeId) || item;
  }
  if(theNode){
    theNode.classList.add('open');
    Html.setHtml(theNode, TPL, item);
  }
}
function initDom(node: HTMLElement){
  theNode = node;
  amplify.subscribe("mpclick",show);
}
function destroyDom(node: HTMLElement){
  theNode = null;
  amplify.unsubscribe("mpclick",show);
}
Html.registerWidget('widget/recipePreview',{initDom,destroyDom})

export{initDom,destroyDom}
